// Polyfill for Promise.withResolvers (used by pdfjs-dist v4).
// Not available in older/embedded browsers, causing:
// "Promise.withResolvers is not a function" when importing PDFs.
if (typeof Promise.withResolvers !== "function") {
    Promise.withResolvers = function withResolvers() {
        let resolve;
        let reject;
        const promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    };
}
